import Vue from 'vue'
import Vuex from 'vuex'
import kpis from './modules/kpis'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    kpis,
  },
})

